var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.66 59.82C119.657 75.6862 113.353 90.9016 102.133 102.12C90.9126 113.338 75.6962 119.64 59.83 119.64C43.9638 119.64 28.7474 113.338 17.5273 102.12C6.30732 90.9016 0.00265188 75.6862 0 59.82C-1.09776e-07 51.9635 1.54762 44.1839 4.55448 36.9256C7.56134 29.6672 11.9685 23.0723 17.5244 17.5173C23.0803 11.9624 29.676 7.55631 36.9348 4.55066C44.1937 1.54501 51.9735 -0.00131001 59.83 3.34451e-06C67.6869 -0.00262405 75.4673 1.5428 82.7267 4.54798C89.9862 7.55317 96.5824 11.9592 102.139 17.5144C107.695 23.0696 112.102 29.6651 115.108 36.924C118.115 44.183 119.661 51.9631 119.66 59.82Z",
    fill: "url(#paint0_linear_2102:3772)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.64 59.82C110.64 73.2956 105.286 86.2194 95.7576 95.7481C86.2289 105.277 73.3052 110.63 59.8295 110.63C46.3539 110.63 33.4302 105.277 23.9014 95.7481C14.3727 86.2194 9.01953 73.2956 9.01953 59.82C9.01822 53.1467 10.3315 46.5385 12.8843 40.3728C15.4372 34.2071 19.1796 28.6046 23.8979 23.8854C28.6162 19.1662 34.2179 15.4227 40.3831 12.8686C46.5483 10.3146 53.1562 9 59.8295 9C66.5028 9 73.1108 10.3146 79.276 12.8686C85.4412 15.4227 91.0429 19.1662 95.7612 23.8854C100.479 28.6046 104.222 34.2071 106.775 40.3728C109.328 46.5385 110.641 53.1467 110.64 59.82V59.82Z",
    fill: "url(#paint1_linear_2102:3772)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M104.69 59.8197C104.691 65.7112 103.532 71.5452 101.278 76.9884C99.0239 82.4317 95.7196 87.3775 91.5537 91.5434C87.3878 95.7093 82.442 99.0137 76.9987 101.268C71.5554 103.522 65.7214 104.681 59.83 104.68C53.938 104.681 48.1035 103.522 42.6597 101.268C37.2159 99.014 32.2694 95.7098 28.1027 91.5441C23.936 87.3783 20.6307 82.4325 18.3757 76.9892C16.1206 71.5459 14.96 65.7116 14.96 59.8197C14.9586 53.9269 16.1183 48.0916 18.3728 42.6471C20.6273 37.2027 23.9323 32.2557 28.0992 28.0889C32.266 23.9221 37.2129 20.617 42.6574 18.3626C48.1019 16.1081 53.9372 14.9484 59.83 14.9497C65.7219 14.9497 71.5561 16.1104 76.9995 18.3654C82.4428 20.6205 87.3885 23.9257 91.5543 28.0924C95.7201 32.2591 99.0242 37.2056 101.278 42.6495C103.532 48.0933 104.691 53.9278 104.69 59.8197V59.8197Z",
    fill: "url(#paint2_linear_2102:3772)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M102.92 59.82C102.915 71.2456 98.3729 82.2016 90.2928 90.2798C82.2127 98.358 71.2556 102.897 59.83 102.9C48.4045 102.9 37.4469 98.3612 29.3678 90.2821C21.2888 82.2031 16.75 71.2455 16.75 59.82C16.7474 54.1614 17.8598 48.5578 20.0237 43.3294C22.1876 38.1009 25.3606 33.3501 29.3614 29.3484C33.3621 25.3468 38.1122 22.1727 43.3401 20.0075C48.5681 17.8424 54.1714 16.7287 59.83 16.73C71.2582 16.73 82.2183 21.2698 90.2992 29.3507C98.3802 37.4317 102.92 48.3918 102.92 59.82V59.82Z",
    fill: "url(#paint3_radial_2102:3772)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M102.92 59.82C102.915 71.2456 98.3729 82.2016 90.2928 90.2798C82.2127 98.358 71.2556 102.897 59.83 102.9C48.4045 102.9 37.4469 98.3612 29.3678 90.2821C21.2888 82.2031 16.75 71.2455 16.75 59.82C16.7474 54.1614 17.8598 48.5578 20.0237 43.3294C22.1876 38.1009 25.3606 33.3501 29.3614 29.3484C33.3621 25.3468 38.1122 22.1727 43.3401 20.0075C48.5681 17.8424 54.1714 16.7287 59.83 16.73C71.2582 16.73 82.2183 21.2698 90.2992 29.3507C98.3802 37.4317 102.92 48.3918 102.92 59.82V59.82Z",
    fill: "url(#paint4_radial_2102:3772)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8295 9C53.1562 9 46.5483 10.3146 40.3831 12.8686C34.2179 15.4227 28.6162 19.1662 23.8979 23.8854C19.1796 28.6046 15.4372 34.2071 12.8843 40.3728C10.3315 46.5385 9.01822 53.1467 9.01953 59.82C9.01953 73.2956 14.3727 86.2194 23.9014 95.7481C33.4302 105.277 46.3539 110.63 59.8295 110.63C73.3052 110.63 86.2289 105.277 95.7576 95.7481C105.286 86.2194 110.64 73.2956 110.64 59.82C110.641 53.1467 109.328 46.5385 106.775 40.3728C104.222 34.2071 100.479 28.6046 95.7612 23.8854C91.0429 19.1662 85.4412 15.4227 79.276 12.8686C73.1108 10.3146 66.5028 9 59.8295 9V9ZM59.8295 109.73C46.5982 109.709 33.9146 104.444 24.5577 95.0889C15.2007 85.7339 9.93333 73.0514 9.90953 59.82C9.92804 46.5852 15.1931 33.8975 24.5506 24.5381C33.9081 15.1787 46.5947 9.91116 59.8295 9.89C73.0644 9.91116 85.7509 15.1787 95.1085 24.5381C104.466 33.8975 109.731 46.5852 109.75 59.82C109.726 73.0514 104.458 85.7339 95.1014 95.0889C85.7445 104.444 73.0609 109.709 59.8295 109.73V109.73Z",
    fill: "url(#paint5_linear_2102:3772)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.83 14.9497C53.9372 14.9484 48.1019 16.1081 42.6574 18.3626C37.2129 20.617 32.266 23.9221 28.0992 28.0889C23.9323 32.2557 20.6273 37.2027 18.3728 42.6471C16.1183 48.0916 14.9586 53.9269 14.96 59.8197C14.96 65.7116 16.1206 71.5459 18.3757 76.9892C20.6307 82.4325 23.936 87.3783 28.1027 91.5441C32.2694 95.7098 37.2159 99.014 42.6597 101.268C48.1035 103.522 53.938 104.681 59.83 104.68C65.7214 104.681 71.5554 103.522 76.9987 101.268C82.442 99.0137 87.3878 95.7093 91.5537 91.5434C95.7196 87.3775 99.0239 82.4317 101.278 76.9884C103.532 71.5452 104.691 65.7112 104.69 59.8197C104.691 53.9278 103.532 48.0933 101.278 42.6495C99.0242 37.2056 95.7201 32.2591 91.5543 28.0924C87.3885 23.9257 82.4428 20.6205 76.9995 18.3654C71.5561 16.1104 65.7219 14.9497 59.83 14.9497V14.9497ZM59.83 103.8C48.1604 103.8 36.9689 99.164 28.7173 90.9124C20.4657 82.6608 15.83 71.4692 15.83 59.7997C15.83 48.1302 20.4657 36.9386 28.7173 28.687C36.9689 20.4354 48.1604 15.7997 59.83 15.7997C65.6081 15.7997 71.3297 16.9378 76.668 19.149C82.0064 21.3602 86.8569 24.6012 90.9427 28.687C95.0284 32.7728 98.2695 37.6233 100.481 42.9616C102.692 48.3 103.83 54.0215 103.83 59.7997C103.83 65.5779 102.692 71.2994 100.481 76.6378C98.2695 81.9761 95.0284 86.8266 90.9427 90.9124C86.8569 94.9982 82.0064 98.2392 76.668 100.45C71.3297 102.662 65.6081 103.8 59.83 103.8V103.8Z",
    fill: "url(#paint6_linear_2102:3772)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.83 3.34451e-06C51.9735 -0.00131001 44.1937 1.54501 36.9348 4.55066C29.676 7.55631 23.0803 11.9624 17.5244 17.5173C11.9685 23.0723 7.56134 29.6672 4.55448 36.9256C1.54762 44.1839 -1.09776e-07 51.9635 0 59.82C0.00265188 75.6862 6.30732 90.9016 17.5273 102.12C28.7474 113.338 43.9638 119.64 59.83 119.64C75.6962 119.64 90.9126 113.338 102.133 102.12C113.353 90.9016 119.657 75.6862 119.66 59.82C119.661 51.9631 118.115 44.183 115.108 36.924C112.102 29.6651 107.695 23.0696 102.139 17.5144C96.5824 11.9592 89.9862 7.55317 82.7267 4.54798C75.4673 1.5428 67.6869 -0.00262405 59.83 3.34451e-06V3.34451e-06ZM59.83 118.75C44.2047 118.734 29.2239 112.521 18.1742 101.473C7.12453 90.4251 0.90853 75.4453 0.889999 59.82C0.905883 44.193 7.12072 29.2106 18.1707 18.1607C29.2206 7.11072 44.203 0.895892 59.83 0.880008C75.457 0.895892 90.4394 7.11072 101.489 18.1607C112.539 29.2106 118.754 44.193 118.77 59.82C118.751 75.4453 112.535 90.4251 101.486 101.473C90.4361 112.521 75.4553 118.734 59.83 118.75V118.75Z",
    fill: "url(#paint7_linear_2102:3772)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.5899 34.7798C19.0639 26.7005 25.6186 19.9656 33.5737 15.2741C41.5288 10.5827 50.5944 8.10554 59.8299 8.09983C73.5411 8.11571 86.686 13.5702 96.3804 23.2664C106.075 32.9626 111.527 46.1086 111.54 59.8198C111.539 62.9794 111.251 66.1324 110.68 69.2398L115.39 69.9198L117.16 70.1598C117.771 66.747 118.079 63.2869 118.08 59.8198C118.081 52.17 116.575 44.5948 113.649 37.527C110.722 30.4592 106.431 24.0372 101.022 18.6279C95.6125 13.2187 89.1906 8.92804 82.1227 6.00117C75.0549 3.0743 67.4798 1.56851 59.8299 1.56983C49.6031 1.56658 39.5559 4.25724 30.6994 9.37099C21.843 14.4847 14.4898 21.8411 9.37988 30.6998C11.0499 32.1298 12.7899 33.4998 14.5899 34.7798Z",
    fill: "url(#paint8_linear_2102:3772)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M100.159 92.1401C95.3177 98.1841 89.1798 103.063 82.1991 106.416C75.2183 109.768 67.5734 111.509 59.8293 111.51C48.6508 111.495 37.7769 107.865 28.8306 101.162C19.8843 94.4596 13.3453 85.0439 10.1893 74.3201C7.7093 73.4301 5.1893 72.5201 2.7793 71.5801C5.48977 84.7083 12.6446 96.5002 23.0371 104.967C33.4297 113.434 46.4242 118.059 59.8293 118.06C69.3663 118.068 78.759 115.732 87.1813 111.257C95.6035 106.783 102.797 100.307 108.129 92.4001C105.459 92.3301 102.809 92.2501 100.159 92.1401Z",
    fill: "url(#paint9_linear_2102:3772)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.16 70.1598C126.55 6.95977 41.8499 -21.6602 9.37988 30.6998C40.5699 -25.9702 129.96 6.62978 117.16 70.1598Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.16 70.1598C126.55 6.95977 41.8499 -21.6602 9.37988 30.6998C40.5699 -25.9702 129.96 6.62978 117.16 70.1598Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M108.751 68.06C116.651 13.51 45.4606 -11.2 18.1406 34C44.3606 -14.91 119.521 13.23 108.751 68.06Z",
    fill: "url(#paint10_linear_2102:3772)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.459 66.3999C109.379 19.9099 47.0595 -1.13014 23.1895 37.3999C46.1495 -4.28014 111.899 19.6999 102.459 66.3999Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9202 102.8C70.9202 126.8 37.7502 120.62 15.7502 96.7998C1.12024 80.9098 -3.24976 55.9798 8.14024 32.5898C-23.2198 89.1398 51.9702 147.45 98.9202 102.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M92.6798 96.7897C50.6998 132.54 -8.13023 85.3997 15.5898 38.1997C-11.8502 86.4797 51.9898 135.11 92.6798 96.7897Z",
    fill: "url(#paint11_linear_2102:3772)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M91.0201 89.8398C57.5001 122.84 3.80009 84.8398 20.8701 42.8398C0.690088 85.9398 58.7801 124.98 91.0201 89.8398Z",
    fill: "url(#paint12_linear_2102:3772)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2102:3772",
    x1: 18.33,
    y1: 18.31,
    x2: 96.78,
    y2: 96.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F1D78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B88435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B58032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BE8D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E6C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#D9B763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C69E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AF8037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A16E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B2843A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CDA757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F2D97F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F5DC82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2102:3772",
    x1: 8.06953,
    y1: 8.06,
    x2: 107.23,
    y2: 107.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F1D78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B88435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B58032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BE8D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A16E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B2843A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CDA757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F5DC82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2102:3772",
    x1: 30.12,
    y1: 25.7197,
    x2: 94.59,
    y2: 99.7097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F1D78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B68133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DDB057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F6CD6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFD876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFF1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F5DC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDA757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A97831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9B6622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2102:3772",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.14 30.7) scale(69.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F5DC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EBCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DCBB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C49B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2702A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2102:3772",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.38 101.02) scale(85.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#14120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2E2818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#51482A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7E7041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B4A05D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F5DC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2102:3772",
    x1: 38.9595,
    y1: 13.47,
    x2: 79.3695,
    y2: 103.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B88435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B58032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BE8D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2102:3772",
    x1: -5592.27,
    y1: -9487.46,
    x2: -1966.28,
    y2: -1435.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B88435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B58032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BE8D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2102:3772",
    x1: -10234.5,
    y1: -14220.4,
    x2: -493.906,
    y2: -1065.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C59743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B98636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B88435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B58032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BE8D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2102:3772",
    x1: 82.3099,
    y1: 4.24983,
    x2: 63.6899,
    y2: 49.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F5DC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B4A05D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7E7041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#51482A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2E2818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#14120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2102:3772",
    x1: 54.9993,
    y1: 93.3701,
    x2: 54.1093,
    y2: 115.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F2E6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDC08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D0A85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#935E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7D4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5A2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2102:3772",
    x1: -3525.37,
    y1: -3959.11,
    x2: -2729.83,
    y2: -6692.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F2E6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDC08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D0A85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#935E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7D4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5A2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2102:3772",
    x1: 4001.77,
    y1: -20868.2,
    x2: 1976.49,
    y2: -18160.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F2E6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDC08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D0A85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#935E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7D4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5A2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2102:3772",
    x1: -2188.87,
    y1: -3705.11,
    x2: -3521.21,
    y2: -1753.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F2E6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDC08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D0A85E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CB9F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B6622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#935E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7D4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5A2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A1900"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.c10db65f8348a0d73b03a3456fa189a1.svg";
export { ForwardRef as ReactComponent };